import { useEffect, useState } from "react";

// 00:17:34 — restarts automatically when it reaches 00:00:00
const TOTAL_SECONDS = 17 * 60 + 34;
const START = Date.now();

function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return TOTAL_SECONDS - (elapsed % (TOTAL_SECONDS + 1));
}

export function useCountdown() {
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const pad = (n: number) => String(n).padStart(2, "0");
  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  };
}
